import i18n from '../../language/index'
const anchor ={
  namespaced:true,
  state:{
    popShow:false,
    popWord:i18n.t('vuex_modules_anchor_296'),
    selectedData:null,
    anchorList:[],
    allAnchorList:{},
  },
  mutations:{
    SET_popShow(state,val){
      state.popShow = val
    },
    SET_popWord(state,val){
      state.popWord = val
    },
    SET_selectedData(state,val){
      state.selectedData = val
    },
    SET_anchorList(state,val){
      state.anchorList = val
    },
    SET_allAnchorList(state,val){
      state.allAnchorList = val
    }

  }

}
export default anchor;



// WEBPACK FOOTER //
// ./src/vuex/modules/anchor.js